// Vendor Libs
import React from 'react';

// Components
import CreateDisplayPath from '../app/create-display-path';
import DisplayPaths from '../search-data/display-paths';
import EditDisplayPath from '../app/edit-display-path';
import FlexDashboard from '../core/flex-dashboard';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

// Styles
import './dashboard-display-paths.scss';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Display Paths',
                                component: DisplayPaths,
                            },
                        ],
                    },
                ],
            },
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Create Display Path',
                        component: CreateDisplayPath,
                        config: {
                            componentProps: {},
                        },
                    },
                    {
                        type: 'tab',
                        name: 'Edit Display Path',
                        component: EditDisplayPath,
                        config: {
                            componentProps: {},
                        },
                    },
                ],
            },
        ],
    },
};

function DashboardDisplayPaths() {
    return <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="displayPaths" />;
}

export default DashboardDisplayPaths;
